import React, { useState } from "react"
import { CustomInput } from "../../common/SimpleInput"
import SubStateMenu from "./SubStateMenu";
import { WorkshopInput } from "../../common/WorkshopInput";
import { useTranslation } from "react-i18next";

function TaxonomyForm(props) {
  const { t } = useTranslation();
  const { 
    taxonomyValues,
    entryChannelsOptions,
    taxonomyOptions,
    caseOptions,
    caseValue,
    changeTaxonomy,
    changeCaseValue,
    changeDate,
    dateValue,
    loading,
    closed,
    caseNumber,
    additionalInfo,
    changeAdditionalInfo,
    changeCaseNumber,
    changeEntryChannel,
    entryChannelValue,
    factoryCloseDateValue,
    scaleDateValue,
    nonPPReasonValue,
    changeFactoryCloseDate,
    changeScaleDate,
    changeNonPPReason,
    changeSubState,
    subStateValue,
    phoneNumber,
    changePhoneNumber,
    changeCaseWorkshop,
    workshopValue,
    MSPPlate,
    changePlate,
    MSPID,
    changeMSPID,
    SupplierId,
    SupplierProtocol,
    changeSupplierProtocol,
    SupplierServiceid,
    changeSupplierServiceId,
    changeSupplierId,
    suppliersOptions, 
    supplierServiceTypesOptions,
  } = props;

  const [showMenu, setShowMenu] = useState(false);

  return (
    <div className="caseform-form" style={{display: "flex", flexFlow: "column", gap: "1rem"}}>
      <div style={{display: "grid", gridTemplateColumns: "repeat(4, 1fr)", rowGap: "1rem", columnGap: "1rem"}}>
          <div>
              <CustomInput label={t("EntryChannel")} type="select" disableClear disabled={loading || closed || !entryChannelsOptions} displayExpr={"description"} valueExpr={"entryChannelId"} options={entryChannelsOptions || []} onChange={(e) => changeEntryChannel(e)} value={entryChannelValue} />
          </div>
          <div>
              <CustomInput label={t("Level1")} type="select" disabled={loading || closed || !taxonomyOptions.level_1} displayExpr={"value"} valueExpr={"key"} options={taxonomyOptions.level_1 || []} onChange={(e) => changeTaxonomy(e, 1)} value={taxonomyValues.taxonomyLevel_1} />
          </div>
          <div>
              <CustomInput label={t("Level2")} type="select" disabled={loading || closed || taxonomyValues.level < 1 || !taxonomyOptions.level_2 || taxonomyOptions.level_2.length === 0} displayExpr={"value"} valueExpr={"key"} options={taxonomyOptions.level_2 || []} onChange={(e) => changeTaxonomy(e, 2)} value={taxonomyValues.taxonomyLevel_2} />
          </div>
          <div>
            <CustomInput label={t("Level3")} type="select" disabled={loading || closed || taxonomyValues.level < 2 || !taxonomyOptions.level_3 || taxonomyOptions.level_3.length === 0} displayExpr={"value"} valueExpr={"key"} options={taxonomyOptions.level_3 || []} onChange={(e) => changeTaxonomy(e, 3)} value={taxonomyValues.taxonomyLevel_3} />
          </div>
        <div>
          <CustomInput label={t("Level4")} type="select" disabled={loading || closed || taxonomyValues.level < 3 || !taxonomyOptions.level_4 || taxonomyOptions.level_4.length === 0} displayExpr={"value"} valueExpr={"key"} options={taxonomyOptions.level_4 || []} onChange={(e) => changeTaxonomy(e, 4)} value={taxonomyValues.taxonomyLevel_4} />
        </div>
        
        {/* <div>
          <CustomInput label={t("Substate")} type="select" disabled={loading || closed} displayExpr={"description"} valueExpr={"subStateId"} options={caseOptions.length > 0 ? caseOptions.find((o)=> o.stateId == caseValue )?.subStates : []} value={subStateValue} onChange={(e)=>changeSubState(e)}/> 
        </div> */}
        {/* <div >
          <CustomInput disabled={closed} onChange={(e) => { changeCaseNumber(e) }} label="Nº de caso en fábrica" type="text" value={caseNumber} />
        </div> */}
        {/* <div >
              <CustomInput disabled={closed} label="Telefone" type="text" onChange={(e)=>{changePhoneNumber(e)}} value={phoneNumber}/>
        </div> */}
        
        <div>
              <CustomInput disabled={closed} onChange={(e) => { changePlate(e) }} label="Placa" type="text" value={MSPPlate} maxValue={50} length={50}/>
        </div>

        <div>
              <CustomInput disabled={closed} onChange={(e) => { changeMSPID(e) }} label="ID MSP" type="text"  value={MSPID} maxValue={50}/>
        </div>

          <div>
                <CustomInput disabled={closed} onChange={(e) => { changeSupplierProtocol(e) }} label="ID Fornecedor" type="text"  value={SupplierProtocol} maxValue={50}/>
          </div>

          <div>
              <CustomInput label={"Fornecedor"} disableClear type="select" disabled={loading || closed || !suppliersOptions} displayExpr={"description"} valueExpr={"supplierId"} options={suppliersOptions || []} value={SupplierId} onChange={(e) => changeSupplierId(e)} /> 
            </div>
            <div>
              <CustomInput label={"Tipo Serviço"} disableClear type="select" disabled={loading || closed || !supplierServiceTypesOptions} displayExpr={"description"} valueExpr={"supplierServiceTypeId"} options={supplierServiceTypesOptions || []} value={SupplierServiceid} onChange={(e) => changeSupplierServiceId(e)} /> 
            </div>

          <div>
              <CustomInput disabled={closed} onChange={(e) => { changeAdditionalInfo(e) }} label={t("AditionalInfo")} type="text"  value={additionalInfo} maxValue={2000}/>
            </div>
          <div>
              <CustomInput label={t("State")} disableClear type="select" disabled={loading || closed} displayExpr={"description"} valueExpr={"stateId"} options={caseOptions} value={caseValue} onChange={(e) => changeCaseValue(e)} /> 
            </div>

          {/* <div style={{gridColumnStart: 1, gridColumnEnd: 5, display: "grid", gridTemplateColumns: "repeat(2, 1fr)", columnGap: "1rem"}}>
            <div>
              <CustomInput disabled={closed} onChange={(e) => { changeAdditionalInfo(e) }} label={t("AditionalInfo")} type="text"  value={additionalInfo} maxValue={2000}/>
            </div>
            <div>
              <CustomInput label={t("State")} disableClear type="select" disabled={loading || closed} displayExpr={"description"} valueExpr={"stateId"} options={caseOptions} value={caseValue} onChange={(e) => changeCaseValue(e)} /> 
            </div>
          </div> */}


        {/* <div >
          <CustomInput label="Fecha agenda" clearField={()=>changeDate(null)} type="date" disabled={loading || closed} onChange={(e) => { changeDate(e) }} value={dateValue} datetype={"datetime"}/>
        </div>
        <div>
          <CustomInput label="Fecha de escalado" clearField={()=>changeScaleDate(null)} type="date" disabled={loading || closed} onChange={(e) => { changeScaleDate(e) }} value={scaleDateValue} datetype={"datetime"}/>
        </div>
        <div >
          <CustomInput label="Fecha de cierre fábrica" clearField={()=>changeFactoryCloseDate(null)} type="date" disabled={loading || closed} onChange={(e) => { changeFactoryCloseDate(e) }} value={factoryCloseDateValue} datetype={"datetime"}/>
        </div>
        <div style={{gridColumnStart: 1, gridColumnEnd: 5, display: "grid", gridTemplateColumns: "repeat(3, 1fr)", columnGap: "1rem"}}>
        <div>
                <CustomInput size={"xxs"} disabled={closed} onChange={(e) => { changeAdditionalInfo(e) }} label="Informação adicional" type="text"  value={additionalInfo} maxValue={2000}/>
          </div>
          <div>
            <CustomInput size={"xxs"}  disabled={closed} onChange={(e) => { changeNonPPReason(e) }}label="Motivo no preferente plus" type="text"  value={nonPPReasonValue} maxValue={200}/>
          </div>
          <div>
            <WorkshopInput onChange={changeCaseWorkshop} value={workshopValue?.workshopInternalId} name={workshopValue?.name}/>
          </div>
        </div> */}
    </div>

      

    </div>
  )
}

export { TaxonomyForm }